import { useContext, useState } from "react";
import { Container } from "@viagogo/core/ui";
import { SecondRow } from "src/website-apps/shared/components/header/SearchEmphasizedBrowseHeader/styled-components";
import { MegaSearch } from "src/website-apps/shared/components/instant-search-redesign-mega-search/MegaSearch";
import { RecentSearchesProvider } from "src/website-apps/shared/components/search/recent-searches/MaybeWithRecentSearchesProvider";
import { SearchTermContext } from "src/website-apps/shared/context/SearchTermContext";
import { FirstRow } from "./FirstRow";

const FullWidthHeaderDesktop = ({ logo, mainNav, discoveryNav, icon, greeting }) => {
  const [isOpen] = useState(false);
  const initialSearchTerm = useContext(SearchTermContext);

  return (
    <Container>
      <FirstRow logo={logo} mainNav={mainNav} discoveryNav={discoveryNav} icon={icon} />
      {greeting}
      <SecondRow $isActive={isOpen}>
        <MegaSearch isEmphasized initialSearchTerm={initialSearchTerm} shouldAutoFocus={false} />
      </SecondRow>
    </Container>
  );
};

/**
 * Header that is configurable
 */
export const SearchEmphasizedHeader = ({ logo, mainNav, discoveryNav, profileIcon, greeting }) => {
  "use no memo"; // Props are components called as functions, so memoized wrappers cause FirstRow to lose their hooks on rerenders
  return (
    <RecentSearchesProvider>
      <FullWidthHeaderDesktop
        logo={() => logo && logo()}
        mainNav={() => mainNav && mainNav()}
        discoveryNav={() => discoveryNav && discoveryNav()}
        icon={profileIcon}
        greeting={greeting}
      />
    </RecentSearchesProvider>
  );
};
